import React from "react";
import { Container, Navbar, Image } from "react-bootstrap";

const NavbarLiora = () => {
  return (
    <Navbar className="bg-navy">
      <Container>
        <Navbar.Brand href="https://liora.io">
          <Image
            src="/assets/liora-logo-white.svg"
            alt="Liora"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>
      </Container>
    </Navbar>
  );
};

export default NavbarLiora;
